import {map} from 'rxjs/operators';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ITableHeader} from '../../../../shared/table/TableComponent';
import {KeepingCurrentReportFormComponent} from '../form/KeepingCurrentReportFormComponent';
import {BehaviorSubject, Observable} from 'rxjs';
import {ConfirmOrphanReport} from '../../../../../services/api.client';
import {SHORT_DATE_FORMAT} from '../../../../../constants';
import {formatDate} from '../../../../../utilities/date-util';
import {formatCurrency} from '../../../../../utilities/Util';

@Component({
    selector: 'orphan-report-component',
    templateUrl: './OrphansReportComponent.html',
    standalone: false
})
export class OrphansReportComponent implements OnInit {

    tableHeaders: ITableHeader[] = [
        {text: 'Agency'},
        {text: 'SSN'},
        {text: 'Customer'},
        {text: 'Account Number'},
        {text: 'Initial Bill Date'},
        {text: 'Program Expiration Date'},
        {text: 'Program Credit'},
        {text: 'Arrears Credit'},
        {text: 'Budget Bill Amount'},
        {text: 'Customer Pay Amount'},
        {text: 'Enrollment Status'},
        {text: 'Rejection Reason'},
        {text: 'Confirm Date'},
        {text: 'Import Date'},
    ];

    @ViewChild('form')
    form: KeepingCurrentReportFormComponent;

    private readonly _report$ = new BehaviorSubject<ConfirmOrphanReport[]>(null);
    report$: Observable<ConfirmOrphanReport[]> = this._report$.asObservable();
    rows: any;

    ngOnInit(): void {
        this.rows = this.report$
            .exists().pipe(
                map((report) => report.map(r => [
                    r.agency,
                    '***-**-' + r.ssn,
                    r.customer,
                    r.accountNumber,
                    formatDate(r.initialBillDate, SHORT_DATE_FORMAT),
                    formatDate(r.programExpiration, SHORT_DATE_FORMAT),
                    formatCurrency(r.programCredit),
                    formatCurrency(r.arrearsCredit),
                    formatCurrency(r.budgetBillAmount),
                    formatCurrency(r.customerPayAmount),
                    r.enrollmentStatus,
                    r.rejectionReason,
                    formatDate(r.confirmDate, SHORT_DATE_FORMAT),
                    formatDate(r.importDate, SHORT_DATE_FORMAT)
                ])));

    }

    submitReport(): void {
        this.form.submitConfirmationOrphansReport().subscribe({next: (report) => this._report$.next(report), error: () => {}});
    }
}
